import { Fragment, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { usePageTitle } from "../../hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import { getLangFromPathname } from "../../utils/langRouting";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Chatbot from "../ChatBot/ChatBot";
import CookieBanner from "../CookieBanner/CookieBanner";
import CookieSettings from "../CookieSettings/CookieSettings";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import PageViewTracker from "../SEO/PageViewTracker";
import layoutStyles from "./RootLayout.module.css";

export default function RootLayout() {
  usePageTitle();
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const langInPath = getLangFromPathname(pathname);
    const desired = langInPath || "ro";
    if (i18n.language !== desired) {
      i18n.changeLanguage(desired);
    }
  }, [i18n, pathname]);

  const canonicalPath = langInPathOrDefault(pathname);
  const fullBleedHero =
    canonicalPath === "/" ||
    canonicalPath === "/services" ||
    canonicalPath === "/portfolio";
  const outletClass = fullBleedHero ? "" : layoutStyles.outletOffset;

  const [showCookieBanner, setShowCookieBanner] = useState(false);

  const handleOpenCookieSettings = () => {
    setShowCookieBanner(true);
  };

  const handleCloseCookieBanner = () => {
    setShowCookieBanner(false);
  };

  return (
    <Fragment>
      <ScrollToTop />
      <PageViewTracker />
      <Header />
      <div className={`${layoutStyles.outletWrapper}${outletClass ? ` ${outletClass}` : ""}`}>
        <Outlet />
      </div>
      <Footer />
      <Chatbot
        welcomeMessage="Hi! I'm here to help you with any questions about Softindex's services. How can I assist you today?"
        companyName="Softindex"
      />

      <CookieBanner />

      {showCookieBanner && (
        <CookieBanner forceShow={true} onClose={handleCloseCookieBanner} />
      )}

      <CookieSettings onOpenSettings={handleOpenCookieSettings} />
    </Fragment>
  );
}

function langInPathOrDefault(pathname) {
  // Use RO paths for layout decisions; /en/... should behave like /...
  const lang = getLangFromPathname(pathname);
  if (!lang) return pathname || "/";
  const rest = String(pathname || "/").replace(new RegExp(`^/${lang}(?=/|$)`), "");
  return rest || "/";
}
